import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	baseRollupLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.rollup.base-rollup-label',
		defaultMessage: 'Roll-up to',
		description: 'Label for roll-up select box',
	},
	rollUpByNone: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.rollup.roll-up-by-none',
		defaultMessage: 'None',
		description: 'Label for roll-up by none',
	},
	rollUpByTeam: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.rollup.roll-up-by-team',
		defaultMessage: 'Team',
		description: 'Label for roll-up by team',
	},
	hierarchyRollupHeading: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.rollup.hierarchy-rollup-heading',
		defaultMessage: 'Hierarchy',
		description: 'Heading text for roll-up by hierarchy',
	},
	otherRollupHeading: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.rollup.other-rollup-heading',
		defaultMessage: 'Others',
		description: 'Heading text for other roll-up options',
	},
	restrictedRollupWithGroupByEpic: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.rollup.restricted-rollup-with-group-by-epic',
		defaultMessage: 'Subtasks are automatically rolled up when grouping by epics',
		description: 'Tooltip to show that the subtasks are rolled up to story when grouping by epics',
	},
	restrictedRollupTeamWithGroupBy: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.rollup.restricted-rollup-team-with-group-by',
		defaultMessage: 'Roll-up to team is not supported when grouping dependencies',
		description:
			'Tooltip to show that roll-up to team is not available when group by is active in dependency report',
	},
});
